import { ElMessageBox } from "element-plus";

/** 检查间隔时间（毫秒） */
const CHECK_INTERVAL = 900 * 1000;
// 添加一个标志来跟踪是否已经显示了更新弹窗
let isUpdateDialogShowing = false;
// 添加一个变量存储用户已拒绝更新的版本
let rejectedVersion: string | null = null;
// 存储当前版本的键名
const VERSION_KEY = "app_version_hash";

// 检查更新函数
export const checkUpdate = async (): Promise<void> => {
  // 如果已经显示了更新弹窗，则跳过检查
  if (isUpdateDialogShowing) {
    return;
  }
  // 如果用户已经拒绝了当前检测到的版本的更新，则不再发送请求
  if (rejectedVersion) {
    // console.log("用户已拒绝更新，跳过检查");
    return;
  }
  try {
    // 开发环境跳过检查
    if (process.env.NODE_ENV === "development") {
      // console.log("开发环境跳过版本检查");
      return;
    }

    // 添加时间戳防止缓存
    const response = await fetch(`/version.json?t=${Date.now()}`);

    if (!response.ok) {
      throw new Error("获取版本信息失败");
    }

    const versionInfo = await response.json();

    // 使用hash作为版本标识
    const currentVersion = versionInfo.hash;

    // 获取页面加载时的版本（从全局变量中获取）
    const pageLoadVersion = (window as any).__APP_VERSION__ || "";

    // 首次访问或页面版本为空时，保存当前版本号
    if (!pageLoadVersion) {
      localStorage.setItem(VERSION_KEY, currentVersion);
      return;
    }

    // 版本不同，提示更新（只有当页面版本不为空且与当前版本不同时）
    if (pageLoadVersion !== currentVersion && pageLoadVersion !== "") {
      // 设置标志，表示正在显示更新弹窗
      isUpdateDialogShowing = true;

      ElMessageBox.confirm(
        "系统已更新，点击【立即更新】即可使用最新功能！",
        "提示",
        {
          confirmButtonText: "立即更新",
          cancelButtonText: "拒绝",
          type: "warning",
          closeOnClickModal: false,
        }
      )
        .then(() => {
          // 更新本地存储的版本号并刷新页面
          localStorage.setItem(VERSION_KEY, currentVersion);
          window.location.reload();
        })
        .catch((error) => {
          console.log("用户取消更新", error);
          // 记录用户拒绝的版本
          rejectedVersion = currentVersion;
          // 重置弹窗显示标志
          isUpdateDialogShowing = false;
        });
    } else {
      // 如果页面已经是最新版本，更新本地存储的版本号
      localStorage.setItem(VERSION_KEY, currentVersion);
    }
  } catch (error) {
    console.error("检查更新出错:", error);
  }
};

// 自动检查更新
export const autoRefresh = (): void => {
  // 定期检查
  setTimeout(function check() {
    checkUpdate().finally(() => {
      if (rejectedVersion) return; // 拒绝后，本次不再检测更新
      setTimeout(check, CHECK_INTERVAL);
    });
  }, CHECK_INTERVAL);
};
